<template>
  <div class="regist">

    <div class="whiteFull">
      <div class="wrapContent">
        <div class="topHead">
          <div class="left">
            <img src="@/assets/image/xlogo.png" alt="">
            <div>
              <p>{{pc_lang.A5bpay}}</p>
              <span>{{pc_lang.Provide_best_quality_security_}}</span>
            </div>
          </div>
          <div class="right">
            {{pc_lang.Sign_Up}}
          </div>
        </div>
      </div>
    </div>

    <div class="wrapContent content">
      <div class="contentTitle">
        <h3>{{pc_lang.Sign_Up}}</h3>
      </div>

      <div class="registStep">
        <el-steps :active="stepActive" align-center>
          <el-step :title="pc_lang.Create_Account" description=""></el-step>
          <el-step :title="pc_lang.Set_login_password" description=""></el-step>
          <el-step :title="pc_lang.Payment_settings" description=""></el-step>
          <el-step :title="pc_lang.Complete" description=""></el-step>
        </el-steps>
      </div>

      <!-- 第一步 -->
      <div class="regist_step_1 regist_step" v-show="stepActive == 0">
        <el-form :model="registForm" :rules="rules" ref="registForm" label-width="0" class="registForm">
          <el-form-item prop="gr">
            <p>{{pc_lang.Nationality__Region}}</p>
            <el-select v-model="registForm.gr" :placeholder="pc_lang.Please_select_your_nationality__region" popper-class="regist_select" size="medium">
              <el-option :label="item.country_name" :value="item.country_code" v-for="item in countryList" :key="item.country_code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="email">
            <p>{{pc_lang.Email_address}}</p>
            <el-input v-model="registForm.email" prefix-icon="el-icon-message" autocomplete="off" :placeholder="pc_lang.Enter_your_email_address" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="mobile">
            <p>{{pc_lang.Ho_No}}</p>
            <el-input v-model="registForm.mobile" :placeholder="pc_lang.Please_enter_the_Hp_No" size="medium">
              <template slot="prepend">+{{registForm.gr}}</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <p>{{pc_lang.SMS_verification_code}}</p>
            <el-input v-model="registForm.code" :placeholder="pc_lang.Enter_verification_code" size="medium" class="opt">
              <template slot="append"><span class="getOPT" @click="getOPT">{{optWords}}</span></template>
            </el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" size="medium" class="nextStep" @click="regForm('registForm', 1)">{{pc_lang.Next_step}}</el-button>
        </div>
      </div>

      <!-- 第二步 -->
      <div class="regist_step_2 regist_step" v-show="stepActive == 1">
        <p>
          <i class="el-icon-warning-outline"></i>
          {{pc_lang.In_order_to_provide_you_with_better_financial_services_identity_information_cannot_be_changed_once_it_is_entered_and_private_information_is_strictly_confidential_without_my_permission}}
        </p>
        <p class="name">{{pc_lang.Username}}：<span v-text="registForm.mobile"></span></p>
        <el-form :model="psdForm" :rules="psdRules" ref="psdForm" label-width="0" class="psdForm">
          <el-form-item prop="password">
            <p>{{pc_lang.Login_password}}</p>
            <el-input type="password" v-model="psdForm.password" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Please_enter_your_login_password" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="checkPassword">
            <p>{{pc_lang.Reenter}}</p>
            <el-input type="password" v-model="psdForm.checkPassword" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Please_enter_your_login_password" size="medium"></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" size="medium" class="nextStep" @click="regForm('psdForm', 2)">{{pc_lang.Next_step}}</el-button>
        </div>
      </div>

      <!-- 第三步 -->
      <div class="regist_step_3 regist_step" v-show="stepActive == 2">
        <p class="name">{{pc_lang.Username}}：<span v-text="registForm.mobile"></span></p>
        <el-form :model="payForm" :rules="payRules" ref="payForm" label-width="0" class="payForm">
          <el-form-item prop="payPassword">
            <p>{{pc_lang.Payment_password}}</p>
            <el-input type="password" v-model="payForm.payPassword" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Please_enter_the_payment_password" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="checkPayPassword">
            <p>{{pc_lang.Reenter}}</p>
            <el-input type="password" v-model="payForm.checkPayPassword" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Please_enter_the_payment_password" size="medium"></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" size="medium" class="nextStep" @click="regForm('payForm', 4)">{{pc_lang.Confirm_submission}}</el-button>
        </div>
      </div>

      <!-- 第四步 -->
      <div class="regist_step_4 regist_step" v-if="stepActive == 4">
        <Finish
        v-if="stepActive == 4"
        :mainTitle="pc_lang.Registration_success"
        :descWord="pc_lang.You_have_successfully_log_in_to_Wu_Shiyi_payment_account"
        :routeA="'/index'"
        :routeWordA="pc_lang.My_Credit"
        :btnBool="false"
        :countBool="true"
        ></Finish>
      </div>


    </div>

  </div>
</template>

<script>
// @ is an alias to /srcim
import * as RegExp from '@/utils/RegExp'
import * as API_USER from '@/api/user'

import Finish from '@/components/ui/Finish'

import { mapGetters } from 'vuex'

export default {
  name: 'Regist',
  components: {
    Finish,
  },
  computed: {
    ...mapGetters(['countryList']),
    rules() {
      // mobile验证
      var validateMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_Hp_No));
        } else if (String(value).length < 8 || String(value).length > 14) {
          callback(new Error(this.pc_lang.please_enter_a_valid_phone_number));
        } else {
          API_USER.checkMobile({mobile: value}).then(res=> {
            if (res.data) {
              callback();
            } else {
              callback(new Error(this.pc_lang.The_phone_number_has_been_registered));
            }
          },rej=> {
            callback(new Error(this.pc_lang.please_enter_a_valid_phone_number));
          })
        }
      };
      // email验证
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_your_email_address));
        } else if (!RegExp.email.test(value)) {
          callback(new Error(this.pc_lang.Enter_your_correct_email_address));
        } else {
          API_USER.checkEmail({email: value}).then(res=> {
            if (res.data) {
              callback();
            } else {
              callback(new Error(this.pc_lang.The_email_has_been_registered));
            }
          },rej=> {
            callback(new Error(this.pc_lang.Enter_your_correct_email_address));
          })
        }
      };
      return {
        gr: [
          { required: true, message: this.pc_lang.Nationality__Region, trigger: 'change' }
        ],
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.pc_lang.Enter_verification_code, trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6个字符', trigger: 'blur' }
        ]
      }
    },
    // 验证码单词
    optWords: {
      get() {
        return this.optWords2 == "" ? this.pc_lang.Get_verification_code : this.optWords2
      },
      set(val) {
        this.optWords2 = val
      }
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Enter_the_password));
      } else if( value.length < 6 || value.length > 20 ) {
        callback(new Error(this.pc_lang['4_to_20_characters_in_length']));
      }else {
        if (this.psdForm.checkPassword !== '') {
          this.$refs.psdForm.validateField('checkPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Please_enter_the_password_again));
      } else if (value !== this.psdForm.password) {
        callback(new Error(this.pc_lang.The_passwords_entered_twice_are_inconsistent));
      } else {
        callback();
      }
    };
    var validatePay = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Enter_the_password));
      } else if( !RegExp.payword.test(value) ) {
        callback(new Error(this.pc_lang.Password_consists_of_6_digits));
      }else {
        if (this.payForm.checkPayPassword !== '') {
          this.$refs.payForm.validateField('checkPayPassword');
        }
        callback();
      }
    };
    var validatePay2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Please_enter_the_password_again));
      } else if (value !== this.payForm.payPassword) {
        callback(new Error(this.pc_lang.The_passwords_entered_twice_are_inconsistent));
      } else {
        callback();
      }
    };
    return {
      stepActive: 0,
      /* 第一步 */
      registForm: {
        gr: '60',
        mobile: '',
        email: '',
        code:''
      },
      /* 第二步 */
      psdForm: {
        password: '',
        checkPassword: '',
      },
      psdRules: {
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      /* 第三步 */
      payForm: {
        payPassword: '',
        checkPayPassword: '',
      },
      payRules: {
        payPassword: [
          { validator: validatePay, trigger: 'blur' }
        ],
        checkPayPassword: [
          { validator: validatePay2, trigger: 'blur' }
        ]
      },
      optBool: 1,
      optWords2: "",
    }
  },
  async mounted() {

  },
  beforeDestroy() {
    try{
      window.clearInterval(this.optTimer)
    }catch(err){}
    this.optTimer = null
  },
  methods: {
    /* 表单验证 */
    regForm(formName, step) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && step != 4) {
          if (step == 1) {
            this.checkCode().then(res=>{
              if (res) {
                this.stepActive = step
              }
            })
          }else{
            this.stepActive = step
          }
        } else if(valid && step == 4){
          let success = await this.sendRegist()
          if (success) {
            this.stepActive = step
          }
        } else {
          return false;
        }
      })
    },
    /* 提交注册信息 */
    async sendRegist() {
      let params = {
        ...this.registForm,
        ...this.psdForm,
        ...this.payForm,
      }
      delete params.checkPassword
      delete params.checkPayPassword
      params.password = md5(params.password)
      params.payPassword = md5(params.payPassword)
      let actCountry = this.countryList.filter(obj=>{
        return obj.country_code == this.registForm.gr
      });
      params.countryId = actCountry[0].country_id
      return await API_USER.register(params).then(res=>{
        console.log(res)
        return 1
      },
      rej=>{
        console.log('rej', rej)
        return 0
      })
    },
    /* 重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 获取验证码 */
    getOPT() {
      if (this.optBool) {
        this.optBool = 0
        let params = {
          ...this.registForm
        }
        API_USER.getOPT(params).then(res=>{
          let num = res.data
          let optTimer = setInterval(()=> {
            num--
            let word = this.pc_lang.Get_the_code_after_3s.replace(/3/, num)
            if (num <= 0) {
              clearInterval(optTimer)
              this.optWords = this.pc_lang.Get_verification_code
              this.optBool = 1
              return false
            }else{
              this.optWords = word
            }
          }, 1000)
        },rej=> {
          this.optBool = 1
          this.$message.error(rej.msg)
        })
      }
    },
    /* 验证验证码 */
    async checkCode() {
      let params = {
        code: this.registForm.code
      }
      console.log(params)
      return await API_USER.checkCode('mobile', this.registForm.mobile, params).then(res=>{
        return 1
      },
      rej=>{
        this.registForm.code = ''
        this.$message.error(this.pc_lang.Verification_code_verified_failed)
        this.$refs['registForm'].validate((value)=>{})
        return 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.registStep{
  margin: 10px auto 40px;
}

.regist_step{
  padding: 0 40px;
  padding-bottom: 40px;
  margin-top: 20px;
  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 20px;
  }
  >p.name{
    font-size: 14px !important;
    margin: 20px 0 20px;
  }
  &.regist_step_1{
    .opt{
      width: 260px;
      .getOPT{
        cursor: pointer;
      }
    }
  }
  &.regist_step_2{
    >p{
      color: #333;
      font-size: 12px;
    }
  }
}

</style>